<template>
  <div class="offers">
    <b-container>
      <b-row>
        <b-col cols="12" sm="12" md="12" lg="12" xl="12"><div class="H2">{{title[language]}}</div></b-col>
      </b-row>
      <b-row>
        <b-col cols="6" sm="6" md="3" lg="3" xl="3">
          <div class="offer distribution">
            <div class="icon"></div>
            <div class="text">{{distribution[language]}}</div>
          </div>
        </b-col>
        <b-col cols="6" sm="6" md="3" lg="3" xl="3">
          <div class="offer marketing">
            <div class="icon"></div>
            <div class="text">{{marketing[language]}}</div>
          </div>
        </b-col>
        <b-col cols="6" sm="6" md="3" lg="3" xl="3">
          <div class="offer international">
            <div class="icon"></div>
            <div class="text">{{international[language]}}</div>
          </div>
        </b-col>
        <b-col cols="6" sm="6" md="3" lg="3" xl="3">
          <div class="offer prof">
            <div class="icon"></div>
            <div class="text">{{prof[language]}}</div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'AppOffers',
  props: {
    language: {
      type: String,
      default: 'ru'
    }
  },
  data() {
    return {
      title: {
        ru: 'Что мы предлагаем',
        en: 'What we offer'
      },
      distribution: {
        ru: 'Развитая сеть дистрибьюторов',
        en: 'Developed network of distributors'
      },
      marketing: {
        ru: 'Маркетинг "Под ключ"',
        en: '"TURN-KEY" marketing'
      },
      international: {
        ru: 'Полный цикл ВЭД',
        en: 'Full-cycle FEA'
      },
      prof: {
        ru: '20 лет в автокомпонентах',
        en: '20 years in automotive components'
      },
    };
  }
}
</script>

<style lang="scss">
@media (min-width: 768px) and (max-width: 991px) {
  .offers .offer .icon{margin: 15px!important;width: 100px!important;height: 100px!important;line-height: 150px!important;}
  .offers .offer .text{font-size: 22px!important;line-height: 22px!important;}
}
@media (min-width: 576px) and (max-width: 767px) {
  .offers .offer .icon{margin: 15px!important;width: 100px!important;height: 100px!important;line-height: 150px!important;}
  .offers .offer .text{font-size: 22px!important;line-height: 22px!important;}
}
@media (max-width: 575px) {
  .offers .offer .icon{margin: 10px!important;width: 100px!important;height: 100px!important;line-height: 150px!important;}
  .offers .offer .text{font-size: 20px!important;line-height: 20px!important;}
}
.offers{padding: 20px 0;}
.offers .offer{text-align: center}
.offers .offer .icon{display: inline-block;cursor: pointer;margin: 15px;width: 125px;height: 125px;border-radius: 50%;text-align: center;position: relative;z-index: 1;line-height: 180px;}
.offers .offer .text{width: 100%;font-size: 28px;line-height: 28px;letter-spacing: -0.65px;font-weight: 500;font-family: 'Open Sans Condensed', sans-serif;}
.offers .distribution .icon{background: #e30610;}
.offers .distribution .icon::before{content: url("../assets/icon_truck.png");}
.offers .marketing .icon{background: #ee7d00;}
.offers .marketing .icon::before{content: url("../assets/icon_marketing.png");}
.offers .international .icon{background: #ffec00;}
.offers .international .icon::before{content: url("../assets/icon_spreading.png");}
.offers .prof .icon{background: #2397D3;}
.offers .prof .icon::before{content: url("../assets/icon_prof.png");}
.offers .offer .icon::before {font-style: normal;font-weight: normal;font-variant: normal;text-transform: none;display: block;}
.offers .offer .icon::after {pointer-events: none;position: absolute;width: 100%;height: 100%;border-radius: 50%;content: '';-webkit-box-sizing: content-box;-moz-box-sizing: content-box;box-sizing: content-box;}
</style>


// WEBPACK FOOTER //
// src/views/Offers.vue